import React from 'react';
import deThiTracNghiem from '../../api/de';
import './style.scss';

const colors = [
  'linear-gradient(135deg, #f7971e 0%, #ffd200 100%)',
  'linear-gradient(135deg, #21d4fd 0%, #b721ff 100%)',
  'linear-gradient(135deg, #f857a6 0%, #ff5858 100%)',
  'linear-gradient(135deg, #43cea2 0%, #185a9d 100%)',
  'linear-gradient(135deg, #ff9966 0%, #ff5e62 100%)',
  'linear-gradient(135deg, #56ab2f 0%, #a8e063 100%)',
];

const QuizList = ({ onSelectQuiz }) => {
  return (
    <div className="quiz-list-bg">
      <h2 className="quiz-title rainbow-text">Chọn đề trắc nghiệm</h2>
      <div className="quiz-list">
        {deThiTracNghiem.map((de, idx) => (
          <div
            key={de.id}
            className="quiz-card"
            style={{ background: colors[idx % colors.length] }}
            onClick={() => onSelectQuiz(de.id)}
          >
            <div className="quiz-card-icon">🎯</div>
            <div className="quiz-card-title">{de.tenDe}</div>
            <div className="quiz-card-count">{de.cauHoi.length} câu hỏi</div>
            <button className="quiz-card-btn">Bắt đầu</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuizList; 